export default class GalleryManager {
    constructor(modalManager, customSlider, sliderManagerClass, swiper, showSwiper = false) {
        this.galleriesGrid = document.querySelectorAll('[data-entity="gallery-grid"]');
        this.modalManager = modalManager;
        this.customSlider = customSlider;
        this.sliderManagerClass = sliderManagerClass;
        this.sliderManager = null;
        this.swiper = swiper;
        this.showSwiper = showSwiper;
        this.eventDelegation();
    }

    eventDelegation() {
        this.galleriesGrid.forEach((gallery) => {
            const sliders = gallery.querySelectorAll('[data-entity="gallery-grid-image"], [data-entity="gallery-grid-slider"]');
            sliders.forEach((slider) => {
                slider.addEventListener('click', () => {
                    const sliderImageText = slider.querySelector('[data-entity="gallery-grid-image-text"]');
                    const showModalGalleryGrid = sliderImageText && sliderImageText.offsetParent !== null;

                    let sliderId = null;
                    if (!showModalGalleryGrid) {
                        sliderId = slider.getAttribute('slider-id');
                    }

                    if (!sliderId || sliderId < 0) {
                        const swiperSlider = slider.querySelector('[name="slider"].swiper-slide-active');
                        if (swiperSlider) {
                            sliderId = swiperSlider.getAttribute('slider-id');
                        }
                    }

                    this._onClickSlider(gallery.getAttribute('data-modal-id'), sliderId);
                });
            });

            if (this.showSwiper) {
                this.sliderManager = new this.sliderManagerClass(this.swiper);
                this.generateSlider(gallery);
            }
        });
    }

    _onClickSlider(modalId, sliderId) {
        let hasSliderId = true;
        if (typeof sliderId == 'undefined' || !sliderId || sliderId < 0) {
            hasSliderId = false;
            sliderId = null;
        }

        this.modalManager.openModal(modalId, !hasSliderId);

        let imageGalleryItemClickListener = document.querySelector('image-gallery-list');
        if (imageGalleryItemClickListener) {
            imageGalleryItemClickListener.onShow(sliderId);
        }
    }

    generateSlider(gallery) {
        this.sliderElement = this._buildSlider(gallery);

        let galleryContainer = document.querySelector('#gallery-container');

        let img = gallery.querySelector('[data-entity="gallery-grid-image"] img');
        if (img) {
            img.addEventListener('load', () => {
                if (galleryContainer) {
                    galleryContainer.style.minHeight = 'initial';
                }

                // Allow safari to show paginator bullets on first load.
                this.sliderElement.slideTo(1);
                this.sliderElement.slideTo(0);
            });
        }
        this.initialized = true;
    }

    _buildSlider(gallery) {
        let imageElement;
        let imageElements = [];
        let imageGallerySlider = gallery.querySelector('[data-entity="gallery-grid-slider"]');
        if (!imageGallerySlider) {
            return;
        }

        for (const image of JSON.parse(gallery.getAttribute('data-images'))) {
            imageElement = document.createElement('img');
            imageElement.setAttribute('src', image);
            imageElement.setAttribute('loading', 'lazy');
            imageElements.push(imageElement)
        }

        let slider = this.customSlider.buildSlider(imageElements, this._onClickSlider.bind(this), true);
        imageGallerySlider.appendChild(slider);

        const templateChild = imageGallerySlider.querySelector('[data-entity="gallery-grid-image"]');
        if (typeof templateChild !== 'undefined' && templateChild) {
            imageGallerySlider.removeChild(templateChild);
        }

        return this.sliderManager.addSlider(
            imageGallerySlider,
            {
                slidesPerView: 1,
                pagination: true,
                centerSlides: true
            }
        );
    }
}
